export default function JobCategories() {
  const categories = [
    {
      title: 'Teknologi Informasi',
      description:
        'Teknik Informatika, Teknologi Informasi, Sistem Informasi, Teknik Komputer, dan sejenisnya.',
      image: '/img/gijinkoku/1-10.png',
    },
    {
      title: 'Konstruksi',
      description: 'Arsitektur, Teknik Sipil, Teknik Bangunan, dan sejenisnya.',
      image: '/img/gijinkoku/1-11.png',
    },
    {
      title: 'Teknik Mesin',
      description:
        'Teknik Mesin, Teknik Mekatronika, Teknik Manufaktur, dan sejenisnya.',
      image: '/img/gijinkoku/1-12.png',
    },
    {
      title: 'Teknik Elektro',
      description:
        'Teknik Elektro, Teknik Listrik, Teknik Elektronika, dan sejenisnya.',
      image: '/img/gijinkoku/1-13.png',
    },
  ]

  return (
    <section className="relative overflow-hidden px-10 py-16">
      <div className="max-w-8xl relative z-10 mx-auto">
        <div className="mb-16 text-center">
          <div className="text-3xl font-bold leading-tight text-gray-700">
            <span>
              Untuk membantu kamu mendapatkan pekerjaan impian di Jepang,{' '}
            </span>
            <span className="text-red-600">YES.co.id</span>
            <span>
              {' '}
              telah merancang program pelatihan N3 Bahasa Jepang sekaligus
              persiapan kerja di Jepang.
            </span>
          </div>
        </div>

        <div className="mt-24 flex flex-wrap justify-center gap-10">
          {categories.map((category, index) => (
            <div
              key={index}
              className="relative z-20 h-[276px] w-[260px] rounded border border-gray-300 bg-white"
            >
              <img
                src={category.image}
                alt={category.title}
                className="relative -top-7 h-[129px] w-[261px] object-cover"
              />
              <div className="p-4">
                <h3 className="mb-2 text-center text-xl font-bold text-gray-700">
                  {category.title}
                </h3>
                <p className="mt-2 text-center text-sm leading-tight text-gray-700">
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
